<template>

    <div>

        <DonationPaymentSuccess
            v-if="cookieData"
            :type="cookieData.meta.type_label"
            :amount="cookieData.amount.toString()"
            :title="cookieData.meta.donation_title"
            :payment="cookieData.meta">
        </DonationPaymentSuccess>

    </div>

</template>

<script>

    import DonationPaymentSuccess from "./DonationPaymentSuccess";
    import Cookies from "js-cookie";

    export default {
        name: 'DonationThankYou',

        components: {
            DonationPaymentSuccess,
        },

        data() {
            return {
                cookie: null,
                cookieData: null
            }
        },

        created() {
            this.cookieData = JSON.parse(Cookies.get('donation_details'));
            Cookies.remove('donation_details');
        },
    }

</script>
